module.exports = __webpack_public_path__ + "static/media/Portrait-10183.369a7d7c.jpg";